export enum VideoRequestStatus {
  InProgress = 0,
  Complete = 1,
  Failed = 2
}

export const VideoRequestStatusLabels = {
  [VideoRequestStatus.InProgress]: "in-progress",
  [VideoRequestStatus.Complete]: "complete",
  [VideoRequestStatus.Failed]: "failed"
} as const;
